export default __webpack_public_path__ + "static/media/foto05.95af871d.png";